import { render } from "./WorkPlanPage.vue?vue&type=template&id=450c9718"
import script from "./WorkPlanPage.vue?vue&type=script&lang=js"
export * from "./WorkPlanPage.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__